module.exports = __GETREMOTE__('MOBILE');